/**
 * A fronteira com o mundo de fora.
 *
 * Os que moram aqui nao sabem o que e empresa, paciente ou medicao - e e por isso
 * que estao juntos. Um fala com a REDE e guarda o token (`ApiClient`), outro decide
 * se o endereco viaja cifrado e com que chave (`history-codec`), outro le a BARRA DE
 * ENDERECOS e recusa o que a aplicacao nao produziu (`SealedHistoryManager`), e o
 * ultimo entrega um ARQUIVO ao leitor, com a funcao que o renderizador instala
 * (`FileSaver`).
 *
 * A pasta se chamava `services/`, e o nome deixou de servir quando cada assunto
 * ganhou o seu `<conceito>.api.ts`: "servico" passou a querer dizer "o que fala com
 * o servidor sobre um assunto", e quem procurasse o servico de empresas abriria
 * esta pasta e nao acharia. `registerServices` mantem o nome porque ali a palavra e
 * do FRAMEWORK - e um `ServiceLike` que se registra no `SingletonServices`.
 */
import { SingletonServices } from 'wdc-cube';
import { ApiClient } from './api-client';
import { SealedHistoryManager } from './sealed-history-manager';
import { currentHistoryCodec, fetchHistoryKey, forgetHistoryKey, keepOnlySealed, publicHistoryCodec, sealAddress, unsealAddress, userHistoryCodec } from './history-codec';
export { safeRead, safeRemove, safeWrite } from './storage';
export { FileSaver } from './file-saver';
export { ApiClient, SealedHistoryManager, currentHistoryCodec, fetchHistoryKey, forgetHistoryKey, keepOnlySealed, publicHistoryCodec, sealAddress, unsealAddress, userHistoryCodec };
/** Chamado pelo renderer antes de `kickStart`. */
export function registerServices() {
    SingletonServices.add(ApiClient.INSTANCE);
}
//# sourceMappingURL=index.js.map